import Vue from 'vue';
import App from './App.vue';
// @ts-ignore
import Vuesax from 'vuesax';
// @ts-ignore
import { VueHammer } from 'vue2-hammer';
import '../themeConfig.js';
import './globalComponents.js';
import router from './router';
// @ts-ignore
import store from './store_vuesax/store';
import Antd from 'ant-design-vue';
import AuthModule from './store/AuthModule';
import './filters/filters';
import 'prismjs';
import 'material-icons/iconfont/material-icons.css';
import 'vuesax/dist/vuesax.css';
import './assets/scss/main.scss';
import '@/assets/css/main.css';
import 'prismjs/themes/prism-tomorrow.css';
import 'bootstrap/dist/css/bootstrap.css'
import moment from 'moment';
import 'moment/locale/fr';
import 'bootstrap/dist/css/bootstrap.css';

moment.locale('fr');

// Feather font icon
require('./assets/css/iconfont.css');

Vue.use(Vuesax);
Vue.use(VueHammer);
Vue.use(Antd);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
